var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#0073c2",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.12386,1.85) scale(2,2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,128) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460,1238c-132,-67 -132,-249 0,-315c56,-29 104,-29 160,0c132,66 132,248 0,315c-24,12 -60,22 -80,22c-20,0 -56,-10 -80,-22zM608,1200c42,-26 72,-76 72,-120c0,-44 -30,-94 -72,-120c-117,-71 -259,71 -188,188c26,42 76,72 120,72c19,0 50,-9 68,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487,1153c-12,-11 -8,-141 4,-149c15,-9 144,58 144,75c0,23 -133,90 -148,74zM570,1080c0,-4 -11,-12 -25,-18c-24,-11 -25,-10 -25,18c0,28 1,29 25,18c14,-6 25,-14 25,-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899,1219c-14,-14 -19,-30 -17,-57c4,-49 31,-51 38,-2l5,35h135h135v-135v-135h-135h-135l-5,75c-4,58 -8,75 -20,75c-12,0 -16,-17 -18,-77c-4,-115 0,-118 178,-118c127,0 142,2 160,20c18,18 20,33 20,160c0,127 -2,142 -20,160c-18,18 -33,20 -160,20c-128,0 -142,-2 -161,-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041,1141c-12,-12 -21,-29 -21,-40c0,-10 -9,-21 -20,-24c-26,-7 -26,-27 -1,-34c14,-4 21,-15 23,-42c4,-50 32,-50 36,0c2,27 9,38 23,42c25,7 24,27 -1,34c-33,9 -20,37 20,43c49,7 47,34 -2,38c-27,2 -43,-3 -57,-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,1047c-3,-7 -4,-87 -3,-177l3,-165h135h135v175v175l-133,3c-102,2 -134,0 -137,-11zM280,880v-140h-100h-100v140v140h100h100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,970c-11,-18 10,-32 41,-28c40,4 38,32 -3,36c-17,2 -34,-2 -38,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,890c-13,-21 11,-31 61,-28c36,2 49,7 49,18c0,19 -99,27 -110,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,810c-13,-21 11,-31 61,-28c36,2 49,7 49,18c0,19 -99,27 -110,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756,894c-36,-47 -40,-64 -19,-71c13,-5 85,86 80,101c-8,24 -28,14 -61,-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826,804c-44,-33 -54,-53 -30,-61c15,-5 106,67 101,80c-7,21 -24,17 -71,-19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,698c-80,-66 -162,-129 -183,-139c-52,-27 -77,-54 -77,-84c0,-13 -11,-35 -25,-49c-30,-30 -32,-59 -5,-86c22,-22 42,-25 71,-9c15,7 24,7 35,-2c9,-7 30,-9 58,-6c41,6 44,5 67,-30c31,-46 49,-58 83,-49c41,10 50,47 24,101c-12,24 -20,46 -17,48c2,3 69,29 149,58c94,36 146,60 148,71c4,19 -99,194 -113,191c-21,-4 -14,-33 26,-102c23,-40 39,-74 36,-77c-3,-3 -76,-32 -164,-65c-87,-33 -177,-71 -200,-85c-60,-35 -77,-31 -107,20c-36,62 -34,80 16,110l42,25l28,-43c32,-52 46,-63 54,-42c3,9 -6,36 -21,62c-15,25 -25,47 -23,48c188,159 247,203 256,194c6,-6 18,-8 27,-5c14,6 14,9 0,37c-8,16 -21,30 -28,30c-6,-1 -77,-55 -157,-122zM260,385c0,-19 -20,-29 -32,-17c-8,8 -7,16 2,26c14,17 30,12 30,-9zM499,331c20,-39 19,-51 -5,-51c-15,0 -56,74 -47,84c15,15 34,3 52,-33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888,708c-47,-10 -64,-32 -34,-44c24,-9 121,20 121,36c0,19 -26,21 -87,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,634c-4,-4 -7,-103 -7,-220v-213l-27,-3c-24,-2 -29,-8 -31,-37c-5,-46 15,-89 49,-106c41,-22 577,-22 618,0c34,17 54,60 49,106c-2,29 -7,35 -30,37l-27,3l-3,107c-2,87 -6,107 -18,107c-12,0 -16,-20 -18,-107l-3,-108h-259h-260v200v199l93,3c74,2 92,6 92,18c0,12 -20,16 -106,18c-58,1 -108,-1 -112,-4zM720,140c0,-49 -91,-85 -103,-40c-3,11 -10,20 -17,20c-7,0 -14,-9 -17,-20c-5,-19 -14,-20 -183,-20c-169,0 -178,1 -183,20c-3,11 -10,20 -17,20c-7,0 -14,-9 -17,-20c-12,-45 -103,-9 -103,40c0,20 7,20 320,20c313,0 320,0 320,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900,600c-18,-18 -20,-33 -20,-160c0,-187 -7,-180 180,-180c128,0 142,2 161,21c14,14 19,30 17,57c-4,49 -31,51 -38,2l-5,-35h-135h-135v135v135h135h135l5,-75c4,-58 8,-75 20,-75c12,0 16,17 18,77c4,115 0,118 -178,118c-127,0 -142,-2 -160,-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005,495c-16,-15 -25,-36 -25,-55c0,-19 9,-40 25,-55c49,-50 135,-15 135,55c0,41 -39,80 -80,80c-19,0 -40,-9 -55,-25zM1090,465c26,-32 -13,-81 -47,-59c-23,14 -28,41 -13,59c16,19 44,19 60,0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.847d6150273a4e745737f763bc79c573.svg";
export { ForwardRef as ReactComponent };